var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"fs-fe__logo",style:({ width: _vm.logo_width + 'px', height: _vm.logo_height + 'px' }),attrs:{"src":_vm.logo_url,"alt":"logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }